module.exports = __webpack_public_path__ + "media/images/how_it_works/step-3-6b9ab245bc2d16fa7376578fbed87fce.svg";